import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M4 22a.97.97 0 0 1-.712-.288A.97.97 0 0 1 3 21v-5q0-.825.587-1.412A1.93 1.93 0 0 1 5 14v-4q0-.825.588-1.412A1.93 1.93 0 0 1 7 8h4V6.55q-.45-.3-.725-.725T10 4.8q0-.375.15-.737.15-.363.45-.663l1.05-1.05q.05-.05.35-.15.05 0 .35.15L13.4 3.4q.3.3.45.663.15.362.15.737 0 .6-.275 1.025A2.5 2.5 0 0 1 13 6.55V8h4q.824 0 1.413.588Q19 9.175 19 10v4q.824 0 1.413.588Q21 15.175 21 16v5q0 .424-.288.712A.97.97 0 0 1 20 22zm3-8h10v-4H7zm-2 6h14v-4H5z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }